import { Apartment, Engineering, Home, Info, Key, Place } from "@mui/icons-material"

const visitorRoute = [
    {
        type: "route",
        name: "Home",
        key: [''],
        route: "",
        icon: <Home size="12px" color="warning" />,
        noCollapse: true,
    },
    {
        type: "route",
        name: "OPD",
        key: ['/opd'],
        route:"/opd",
        icon: <Apartment size="12px" color="primary" />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Paket Pekerjaan",
        key: ['paket-pekerjaan', 'proyek-strategis', 'paket-dak'],
        icon: <Engineering size="12px" color="secondary" />,
        collapse: [
            {
                name: "Belanja",
                key: ['belanja'],
                route: "belanja",
            },
            {
                name: "Proyek Strategis",
                key: ['/proyek-strategis'],
                route: "/proyek-strategis",
            },
            {
                name: "Proyek DAK",
                key: ['paket-dak'],
                route: "paket-dak",
            },
        ],
    },
    {
        type: "route",
        name: "Lokasi Pekerjaan",
        key: ['/lokasi-pekerjaan'],
        route:"/lokasi-pekerjaan",
        icon: <Place size="12px" color="success" />,
        noCollapse: true,
    },
    {
        type: "collapse",
        name: "Tentang",
        key: ['dtd', 'pt', 'bansos'],
        icon: <Info size="12px" color="info" />,
        collapse: [
            {
                name: "Tim",
                key: ["/struktur-tim"],
                route: "/struktur-tim"
            },
            {
                name: "Dasar Hukum",
                key: ["/dasar-hukum"],
                route: "/dasar-hukum"
            },
            {
                name: "Kontak",
                key: ["/kontak"],
                route: "/kontak"
            }
        ],
    },
    {
        type: "route",
        name: "Sign In",
        key: ['/login'],
        route:"/login",
        icon: <Key size="12px" color="error" />,
        noCollapse: true,
    }
]

export default visitorRoute